import { ProjectStatus } from '@/types/projects/ProjectStatus';
import { useTranslation } from '@/i18n';

interface ProjectStatusCellProps {
  status: ProjectStatus;
}

const ProjectStatusCell = ({ status }: ProjectStatusCellProps) => {
  const { t } = useTranslation();
  const colorMap = {
    [ProjectStatus.RESERVED]:
      'border-success-200 bg-success-50 text-success-700',
    [ProjectStatus.PENDING]: 'border-sky-200 bg-sky-50 text-sky-700',
  };
  return (
    <span
      className={`px-2 py-0.5 border rounded-lg text-sm font-medium ${colorMap[status]}`}
    >
      {status === ProjectStatus.RESERVED
        ? t('project.statusType.reserved')
        : t('project.statusType.pending')}
    </span>
  );
};

export default ProjectStatusCell;
